import { Box, Stack } from 'src/components';

import googlePlay from 'src/assets/google-playstore-badge.png';
import appStore from 'src/assets/apple-appstore-badge.svg';

export default function DownloadButtons({displayInlineOnMobile = false}) {

  return (
        <Stack
            direction={{ xs: displayInlineOnMobile ? 'row' : 'column', sm: 'row' }}
            spacing={2}
            mt={4}
            alignItems="center"
            justifyContent="center">

            <a
                href="https://apps.apple.com/us/app/panam-explorer/id6752216637"
                target="_blank"
                rel="noopener noreferrer">
                    <Box
                        component="img"
                        src={appStore}
                        alt="Download on the App Store"
                        sx={{
                            height: 48,
                            transition: 'opacity 0.3s',
                            '&:hover': { opacity: 0.8 },
                        }}
                    />
            </a>

            <a
                href="https://play.google.com/store/apps/details?id=com.panamhighway.panamexplorer"
                target="_blank"
                rel="noopener noreferrer">
                    <Box
                        component="img"
                        src={googlePlay}
                        alt="Get it on Google Play"
                        sx={{
                            height: 48,
                            transition: 'opacity 0.3s',
                            '&:hover': { opacity: 0.8 },
                        }}
                    />
            </a>

        </Stack>
    );
};
